import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {videoData} from "../../../_data/videosData";
import useWindowDimensions from "../../../../../hook/useWindowDimension";
import tutosImg from "../../../../../assets/icons/playTuto.svg";
import play from "../../../assets/icon/play.svg";
import {getUploadUrl} from "../../../../../utils/baseUrl";

const VideosPage = ({
                        setShowVideoModal,
                        setSelectedVideo,
                        setSheetsVideosModalButton,
                        handleOpenNavItem,
                        navItem
                    }) => {
    const {width} = useWindowDimensions();
    useEffect(() =>
            setSheetsVideosModalButton(false),
        []);
    const handleOpenVideo = (url) => {
// On ouvre la modale Vidéo
        setShowVideoModal(true);
// On attribue l'url de la vidéo qui a été passé en paramètre de la fonction et que l'on va transmettre dans la modale
// par l'intermédiaire de la prop "selectedVideo" que l'on retrouve dans le composant Home
        setSelectedVideo(url);
    };
    let firstVideosOfArray = [videoData[0], videoData[1], videoData[2], videoData[3], videoData[4]];

    return (
        <> {navItem !== "pepiteInfos-tutos"
            ?
            <>
                <div>
                    <h3><img src={tutosImg}/>Les tutos</h3>
                    <p onClick={() => {
                        const title = "pepiteInfos-tutos";
                        handleOpenNavItem(title);
                    }} className={"voirTout"}>Voir tout</p>
                </div>
                <ul className={"mobile-list-container-ul horizontal-scroll list-cases"}
                    id={"sheets"}>
                    {firstVideosOfArray.map((video, index) => {
                            return (
                                ((width < 599) || (width > 599 && index < 4)) &&
                                <li key={video.titre} onClick={() => handleOpenVideo(video.url)}
                                    className={"li-video"}>
                                    <div className={"img"}
                                         style={{backgroundImage: `url(${getUploadUrl()}/tutos/${video.n}.jpeg)`}}>
                                    </div>
                                    <h1>{video.titre}</h1>
                                </li>
                            );
                        }
                    )}
                </ul>
            </>
            : <>
                <h3>
                    <img src={tutosImg}/> Les tutos <strong>d&apos;Esther et Philippe</strong>
                    <p>Retrouvez tous les bons gestes pour le confort et le bien-être de vos proches.</p>
                </h3>
                <ul>
                    {videoData.map((video) => (
                        <li key={video.titre} onClick={() => handleOpenVideo(video.url)} className={"li-video"}>
                            <div className={"img"}
                                 style={{backgroundImage: `url(${getUploadUrl()}/tutos/${video.n}.jpeg)`}}>
                            </div>
                            <div className={"play"}><img src={play}/></div>
                            <h1>{video.titre}</h1>
                        </li>
                    ))
                    }
                </ul>
            </>
        }
        </>
    );
};

VideosPage.propTypes = {
    setSelectedVideo: PropTypes.func,
    setShowVideoModal: PropTypes.func,
    selectedVideo: PropTypes.string,
    setSheetsVideosModalButton: PropTypes.func,
    setClassname: PropTypes.func,
    handleOpenNavItem: PropTypes.func,
    navItem: PropTypes.string
};

export default VideosPage;
